import { render, staticRenderFns } from "./watch-playlist.vue?vue&type=template&id=67425a1b&scoped=true&"
import script from "./watch-playlist.vue?vue&type=script&lang=js&"
export * from "./watch-playlist.vue?vue&type=script&lang=js&"
import style0 from "./watch-playlist.vue?vue&type=style&index=0&id=67425a1b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67425a1b",
  null
  
)

export default component.exports